import type { PortalApplication } from "../types/portal";

export const applications: PortalApplication[] = [
  {
    id: "design-project-tracking",
    accessCode: "design",
    name: "Design Project Tracking",
    description: "Enable design team members to update and monitor project progress.",
    category: "Project Management",
    publicUrl: "https://www.design.prt-technology.com/",
    statusApiEndpoint: "/api/status/design-project-tracking",
    icon: "drawing",
    section: "applications",
    enabled: true,
    comingSoon: false,
    statusCheckEnabled: true,
  },
  {
    id: "production-bridge-calculator",
    accessCode: "bridge",
    name: "Production Bridge Calculator",
    description: "Calculate dipping-process bridge dimensions.",
    category: "Process Engineering",
    publicUrl: "https://www.prt-technology.com/bridge-calculator/",
    publicAccess: true,
    showUrl: false,
    statusApiEndpoint: "/api/status/production-bridge-calculator",
    icon: "drawing",
    section: "applications",
    enabled: true,
    comingSoon: false,
    statusCheckEnabled: true,
  },
  {
    id: "oven-ducting-calculator",
    name: "Oven Ducting Flow Calculator",
    description: "Estimate perforated-duct airflow, outlet velocity and pressure requirements.",
    category: "Process Engineering",
    publicUrl: "https://www.prt-technology.com/oven-ducting-calculator/",
    publicAccess: true,
    showUrl: false,
    statusApiEndpoint: "/api/status/oven-ducting-calculator",
    icon: "drawing",
    section: "applications",
    enabled: true,
    comingSoon: false,
    statusCheckEnabled: true,
  },
  {
    id: "ai-knowledge-assistant",
    accessCode: "ai",
    name: "AI Knowledge Assistant",
    description: "Ask questions across approved PRT knowledge and receive source-backed answers.",
    category: "AI & Knowledge",
    publicUrl: "https://ai.prt-technology.com/",
    statusApiEndpoint: "/api/status/ai-knowledge-assistant",
    icon: "assistant",
    section: "applications",
    enabled: true,
    comingSoon: false,
    statusCheckEnabled: true,
  },
  {
    id: "prt-documentation",
    name: "PRT Documentation",
    description: "Browse PRT Technology documentation and guides.",
    category: "Documentation",
    publicUrl: "https://docs.prt-technology.com/",
    publicAccess: true,
    statusApiEndpoint: "/api/status/prt-documentation",
    icon: "drawing",
    section: "applications",
    enabled: true,
    comingSoon: false,
    statusCheckEnabled: true,
  },
  {
    id: "drawing-requests",
    accessCode: "drf",
    name: "Drawing Requests",
    description: "Submit and track requests for technical drawings and drawing-related support.",
    category: "Technology Services",
    publicUrl: "https://www.drf.prt-technology.com/",
    statusApiEndpoint: "/api/status/drawing-requests",
    icon: "drawing",
    section: "services",
    enabled: true,
    comingSoon: false,
    statusCheckEnabled: true,
  },
  {
    id: "change-requests",
    name: "Change Requests",
    description: "Submit new project requests or request changes to an existing project scope.",
    category: "Technology Services",
    icon: "change",
    section: "services",
    enabled: false,
    comingSoon: true,
    statusCheckEnabled: false,
  },
];

export const portalConfig = {
  productionUrl: "https://www.prt-technology.com",
  authUrl: "https://auth.prt-technology.com",
  pollingIntervalMs: 5 * 60_000,
} as const;
